import type { UnitDefinition } from '../../../shared/game/world-types.js';
import type { CharacterRig } from './character-model.js';
import type { CharacterAnimator } from './character-animator.js';
import { MaleAnimator } from './human-male-animator.js';
import { FemaleAnimator } from './human-female-animator.js';

/**
 * Every human is animated by the animator of its own body: the male and the female are separate classes with their own pose code and
 * their own constants (see `human-male-animator.ts` and `human-female-animator.ts`). Use this instead of constructing one directly.
 */
export function createCharacterAnimator(rig: CharacterRig, definition: UnitDefinition): CharacterAnimator {
  return rig.proportions.motionRig === 'human-female' ? new FemaleAnimator(rig, definition) : new MaleAnimator(rig, definition);
}
